import { DexfSettingsFilterSegmentEnum } from '@inter-ikea-kompis/enums';
import { getQueryParams } from './getQueryParams';
const DEV_DEBUG = 'debug';
const DEV_COOKIE = 'cookieConsent';
const options = [DEV_DEBUG, DEV_COOKIE];
const isDevOption = (x) => options.includes(x);
const getDevParams = () => {
    const dev = getQueryParams('dev');
    if (dev && isDevEnv()) {
        return dev.split(',').filter(isDevOption);
    }
    return [];
};
const isDevEnabled = (feature) => getDevParams().includes(feature);
export const isDevDebug = () => isDevEnabled(DEV_DEBUG);
export const isDevCookieConsent = () => isDevEnabled(DEV_COOKIE);
export const isDevEnv = () => {
    return isVerificationEnv() || isLocalEnv();
};
export const isVerificationEnv = () => {
    const { hostname } = window.location;
    return hostname === 'cte.ikeadt.com' || hostname === 'www.cte.ikeadt.com';
};
export const isLocalEnv = () => {
    const { hostname } = window.location;
    return ['localhost', '127.0.0.1'].includes(hostname);
};
export const getCurrentDexfSegment = () => {
    if (isVerificationEnv()) {
        return DexfSettingsFilterSegmentEnum.verification;
    }
    return isDevEnv()
        ? DexfSettingsFilterSegmentEnum.development
        : DexfSettingsFilterSegmentEnum.production;
};
export const isInsightsQa = () => {
    const insights = getQueryParams('insights');
    return insights === 'qa';
};
//# sourceMappingURL=getDevEnv.js.map